// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-expired {
    background-color: #e76f51;
}

.order-expiring {
    background-color: #e9c46a;
}

.header-tools {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Orders.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf","sourcesContent":[".order-expired {\n    background-color: #e76f51;\n}\n\n.order-expiring {\n    background-color: #e9c46a;\n}\n\n.header-tools {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
